import { v4 as uuid } from 'uuid';
import { UniInput } from './UniInput';
import { UniOption } from './UniOption';
import { UniQuestion } from './UniQuestion';

export class UniForm {

  static END_POINT = "uni_form";
  //#region  --- Columns ---
  serno = 0;
  guid;//= uuid();

  func_guid = "";

  /** 是否為當前版本: 0=否, 1=是 */
  is_curr = 0;

  /** 版本序號 */
  ver = 0;

  form_code = "";
  form_title = "";
  //#endregion

  //#region --- View ---
  func_code: string | null = null;
  func_title: string | null = null;
  //#endregion

  constructor() {
    this.guid = uuid().toUpperCase().substring(0, 8);// 只取前8碼 常用但少新增
  }

  //#region --- 手動填入 ---
  AllQuestions?: UniQuestion[];
  AllOptions?: UniOption[];
  AllInputs?: UniInput[];
  //#endregion


}